import { render, staticRenderFns } from "./ForumGroupMembers.vue?vue&type=template&id=5191f115&scoped=true&"
import script from "./ForumGroupMembers.vue?vue&type=script&lang=js&"
export * from "./ForumGroupMembers.vue?vue&type=script&lang=js&"
import style0 from "./ForumGroupMembers.vue?vue&type=style&index=0&id=5191f115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191f115",
  null
  
)

export default component.exports